"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tableCommonStyles = exports.bodyWrapper = exports.scrollableHeader = void 0;

var _reactEmotion = require("react-emotion");

var scrollableHeader = function scrollableHeader(hasFixed) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)(hasFixed && "\n    overflow: scroll;\n    position: fixed;\n    top: 0;\n    max-width: 100%;\n    transform: translate3d(0, -100vh, 0);\n    transition: 0.5s ease;\n    background: transparent;\n    z-index: 1;\n    ::-webkit-scrollbar {\n      width: 0px;\n      background: transparent;\n    }\n    scrollbar-width: none;\n    > table {\n      background: #fff;\n    }\n  ")
  );
};

exports.scrollableHeader = scrollableHeader;

var bodyWrapper = function bodyWrapper() {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("overflow-y:auto;position:relative;")
  );
};

exports.bodyWrapper = bodyWrapper;

var tableCommonStyles = function tableCommonStyles(loading, hasFixed, tableType) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("border-collapse:collapse;border-spacing:0;table-layout:fixed;transition:opacity 0.25s;", loading && "\n    opacity: 0.26;\n  ", "\n\n  ", tableType === 'main' && "\n    width: 100%;\n  ")
  );
};

exports.tableCommonStyles = tableCommonStyles;